var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 512 512"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "a"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 256,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 0h512v512H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "m256 133.6 27.6 85H373L300.7 271l27.6 85-72.3-52.5-72.3 52.6 27.6-85-72.3-52.6h89.4z"
}))));
export default __webpack_public_path__ + "static/media/vn.27a9d18e.svg";
export { SvgComponent as ReactComponent };